export default __webpack_public_path__ + "static/media/nosotros-4.66691d12.jpg";